/**
 * @fileoverview No Venues Warning component.
 * @summary Displays warning when no venues are available.
 *
 * @package KaraoNow
 * @module apps/front/src/pages/organizer/components/NoVenuesWarning
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

interface NoVenuesWarningProps {
  onCreateVenue: () => void
}

/**
 * @summary No venues warning component.
 * @param {NoVenuesWarningProps} props - Component props.
 * @returns {React.ReactElement} Warning or null.
 */
export function NoVenuesWarning({ onCreateVenue }: NoVenuesWarningProps) {
  const { t } = useTranslation()

  return (
    <div className="mb-6 p-6 bg-yellow-100 dark:bg-yellow-900/30 border border-yellow-400 dark:border-yellow-700 rounded-lg">
      <div className="flex items-start gap-3">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="w-6 h-6 text-yellow-600 dark:text-yellow-400 mt-1"
        />
        <div className="flex-1">
          <p className="text-yellow-800 dark:text-yellow-200 mb-4">
            {t('events.noVenues') || 'No venues available. Please create a venue first.'}
          </p>
          
        </div>
        
      </div>
      <button
            onClick={onCreateVenue}
            className="btn btn-primary"
          >
            {t('events.createVenue') || 'Create Venue'}
          </button>
    </div>
  )
}

